
import { Injectable, Inject, PLATFORM_ID, NgZone } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpService } from './http.service';
import { Subject } from 'rxjs';
import { configs } from '../configs/app.config';

@Injectable({providedIn:'root'})

export class GlobalService {
    public previousSize = 0;
    public isBrowser: boolean = false;   // check browser
    public isMobile: boolean = false;   // check the device is mobile
    public customMobileWidth: boolean = false;
    public showSideBarComponent: boolean = false;  //show/hide sidebar component
    public isDesktopMode: boolean = false;  // desktop
    public videoshow:boolean = true;
    public countryList: Array<any> = [];  // country list
    public upDatedpageDateArray: Array<any> = [];
    public upDatedpageBenchDateArray: Array<any> = [];
    public autoCompleteArray: Array<any> = [];
    public alertDetails: any;
    public showPopUp: string = "";
    public sideTrue: boolean = false;
    public isPopUpActive: boolean = true;
    public showTrue: boolean = true;
    public getGraphscale: Array<any> = [];
    public noOfRecordsPerPage: number = 10;
    public testIdsArray: Array<any> = [];
    private updateTestIdMethodSource = new Subject<any>();
    private updateCardSourceMethodSource = new Subject<any>();
    private updateTrendAnalysisMethodSource = new Subject<any>();
    private updateGraphSourceMethodSource = new Subject<any>();
    private updateMainAppTypeMethodSource = new Subject<any>();
    private pointShowMethodSource = new Subject<any>();
    private pointShowMethodDiagnosticSource=new Subject<any>();
    private headerSearchMethodSource = new Subject<any>();
    public locationList: Array<any> = [];
    public networkList: Array<any> = [];
    public speedList: Array<any> = [];
    public currentTimeValue:number;
    public kpiList: Array<any> = [];
    public ApplicationVersionList: Array<any> = [];
    public multiselectAppsList: Array<any> = [];
    public appsList: Array<any> = [];
    public deviceCategoryList: Array<any> = [];
    public timeWindowList: Array<any> = [];
    public order_id: any;
    public selectedOrder: Object = {};
    public orderType: any;
    public dropdownList: Array<any> = [];
    public diagnosticDataparams:Array<any> = [];
    public multiSelectDeviceCategory: Array<any> = [];
    public multiSelectAppVersion: Array<any> = [];
    public multiSelectTimeWindow: Array<any> = [];
    public multiSelectNetwork: Array<any> = [];
    public multiSelectSpeed: Array<any> = [];
    public multiSelectPlatform: Array<any> = [];
    public userDetails: object = {};
    public selectedNumberOfKpis = [];
    public pointShow:any=0;
    public xValue: Array<any> = [];
    public pagecount:number=0;
    public orderList = [];
    public kpiType:Array<object>=[{id:true,list:'Metrics'},{id:false,list:'Index'}];
    public cardKpiType:string='Index';
    public id = 'Select';
    public orderName: string = "";
    public loader:boolean=false;
 public csvUrl:any="";

    public appList: Array<any> = [];
    public organisationOptions: any = [
      { "group_id": 1, "group_name": "test" },
      { "group_id": 12, "group_name": "test1" },
      { "group_id": 13, "group_name": "test2" },
      { "group_id": 14, "group_name": "test3" },
      { "group_id": 15, "group_name": "test4" },
    ];
    public streamType: any = [
      { "streamType_id": 1, "streamType": "Live" },
      { "streamType_id": 2, "streamType": "VOD" }
  
    ];
    public userActionType: string = '';
    public subUserDetails: any ;

  
    constructor(@Inject(PLATFORM_ID) private platformId: Object, private ngZone: NgZone, private httpService: HttpService) {
      if(localStorage.getItem('isLoggedIn'))
      this.CallOnlOgin();
    }

    public CallOnlOgin(){
      this.selectedOrder = [];
      this.order_id='';
      this.orderType='';
      this.orderName='';
      this.userDetails = localStorage.getItem('userDetails') ? JSON.parse(localStorage.getItem('userDetails')) : "";
  
      if (isPlatformBrowser(this.platformId)) {
        this.isBrowser = true;
        this.detectDevice(null);
        let inter = setInterval(() => {
          let token: any = localStorage.getItem('authKey');
          let selectedOrder=localStorage.getItem('selectedOrder')?JSON.parse(localStorage.getItem('selectedOrder')):'';
          if (token) {
            clearInterval(inter);
            this.httpService.createGetRequest(configs['api']['fetchOrderList'])
              .subscribe((res) => {
                this.orderList = res && res['list'] && res['list'].length > 0 ? res.list : [];
                const element = this.orderList[0];
              if(selectedOrder) {this.updateOrderIdMethod(selectedOrder);}else this.updateOrderIdMethod(element);
              },(error)=>{
                if(error){
                  if(error && error['statusCode'] != 404)
alert(`We are experiencing some issues with our services. Please bear with us as our engineers are solving the problem. 

If you're facing such issues frequently or are stuck, please reach out to us at aquamark-support@mozark.ai and we will reach out to you as soon as possible. 
                  `);
                }
              });
          }
        }, 100);
  
  
  
        window.onresize = (e) => {
          //ngZone.run will help to run change detection
          this.ngZone.run(() => {
            this.detectDevice(window.innerWidth);
  
          });
        }
      };
    }
    public isAllRead: boolean = true;
  
    public fetchAlertList(): void {
      this.httpService.createGetRequest(configs['api']['fetchAlertList'] + this.order_id + '?satisfied=true')
        .subscribe((res) => {
          if (res && res['list']) {
            this.isAllRead = res['list'].every(el => el['viewed'] == true);
        }
        });
    }
    private updateOrderIdMethodSource = new Subject<any>();
    updateOrderIdMethod$ = this.updateOrderIdMethodSource.asObservable();
    updateOrderIdMethod = (element) => {
      if (element) {
        this.selectedOrder = element;
        if(this.isBrowser){
          let selectedOrder=localStorage.getItem('selectedOrder')?JSON.parse(localStorage.getItem('selectedOrder')):'';

          localStorage.setItem('selectedOrder',JSON.stringify(this.selectedOrder));
          if(selectedOrder && this.selectedOrder['id']!==selectedOrder){
          localStorage.removeItem('testIdDetails');
          }
        }
        this.appList.push({ id: this.selectedOrder['mainApp'], list: this.selectedOrder['mainApp'] });
        this.csvUrl="";
      this.externalAnalysisList=[];
      this.loader=false;

        if (this.isBrowser)
          localStorage.setItem('product_id', this.selectedOrder['id']);
        this.order_id = this.selectedOrder['id'];//res.list[0].id;
        this.orderType = this.selectedOrder['type'];
        this.orderName = this.selectedOrder['orderName'];
        this.updateMainAppTypeMethod(this.orderType);
      }
      this.fetchExternalAnalysis();
      this.fetchAppList();
      this.fetchCitiesList();
      this.fetchAlertList();
      this.fetchSpeedList();
      this.fetchNetworkList();
      this.fetchKpiList();
      this.fetchApplicationVersionList();
      this.fetchdeviceCategoryList();
      this.fetchtimeWindowList();
      this.fetchPlatformList();
      // this.fetchxValueList();
    }
  
    
    public monthchange(value) {
      let m = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
        "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
      return m[value - 1];
    }
  
    public convertDate(str) {
      var date = new Date(str),
        mnth = ("" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [day, this.monthchange(mnth), date.getFullYear()].join("-");
    }
  
    public toObject(type, arr) {
      let keyInd: any = Object.keys(arr).toString();
      let array;
      if (type == "multi-select") {
        array = [].concat.apply([], arr.list.map((key, index) => ({ item_id: index + 1, item_text: key })));
      } else {
        array = [].concat.apply([], arr.list.map((key, index) => ({ [keyInd]: key, id: key })));
      }
      return array;
    }
  
    updateTestIdMethod$ = this.updateTestIdMethodSource.asObservable();
    updateTestIdMethod = (event) => {
      this.updateTestIdMethodSource.next(event);
    }
  
    updateCardSourceMethod$ = this.updateCardSourceMethodSource.asObservable();
    updateCardSourceMethod = (event) => {
      this.updateCardSourceMethodSource.next(event);
    }
    
    updateTrendAnalysisMethod$ = this.updateTrendAnalysisMethodSource.asObservable();
    updateTrendAnalysisMethod = (event) => {
      this.updateTrendAnalysisMethodSource.next(event);
    }

    pointShowMethod$ = this.pointShowMethodSource.asObservable();
    pointShowMethod = (event) => {
      this.pointShowMethodSource.next(event);
    }

    pointShowMethodDiagnostic$ = this.pointShowMethodDiagnosticSource.asObservable();
    pointShowMethodDiagnostic = (event) => {
      this.pointShowMethodDiagnosticSource.next(event);
    }

    
    updateGraphSourceMethod$ = this.updateGraphSourceMethodSource.asObservable();
    updateGraphSourceMethod = (event) => {
      this.updateGraphSourceMethodSource.next(event);
    }
  
    updateMainAppTypeMethod$ = this.updateMainAppTypeMethodSource.asObservable();
    updateMainAppTypeMethod = (event) => {
      this.updateMainAppTypeMethodSource.next(event);
    }
    headerSearchMethod$ = this.headerSearchMethodSource.asObservable();
    headerSearchMethod = (event) => {
      setTimeout(() => {
        this.headerSearchMethodSource.next(event);
  
      }, 100);
    }
    public externalAnalysisList:Array<object>=[];
    public externalAnalysisName:Array<object>=[];
    public externalAnalysisType:Array<object>=[];
    public fetchExternalAnalysis(){
      this.httpService.createGetRequest(configs['api']['externalAnalysis'] + this.order_id).subscribe((response: any) => {
        if(response && response['list']){
          for(let obj of response['list']){
            this.externalAnalysisName=[];
            this.externalAnalysisType=[];
             this.externalAnalysisName.push(obj['name']);
             this.externalAnalysisType.push(obj['data']['type']);
          }
          if (this.externalAnalysisName && this.externalAnalysisName.length > 0) {
            let response: any = { 'list': '' };
            response['list'] = this.externalAnalysisName;
            this.externalAnalysisName = this.toObject('', response);
          }
          if (this.externalAnalysisType && this.externalAnalysisType.length > 0) {
            let response: any = { 'list': '' };
            response['list'] = this.externalAnalysisType;
            this.externalAnalysisType = this.toObject('', response);
          }
        this.externalAnalysisList=response['list'];
        }
      },
  
      );
    }
    public scrollToTop() {
      let ele: any = document.getElementById('forScroll');
      if (ele)
        ele.scrollTop = 0;
    }
  
    private fetchdeviceCategoryList(): void {
  
      this.httpService.createGetRequest(configs['api']['fetchDevicecategory'] + this.order_id).subscribe((response: any) => {
        this.multiSelectDeviceCategory = this.toObject("multi-select", response);
        this.deviceCategoryList = this.toObject('', response);
      },
  
      );
    }
  
    private fetchtimeWindowList(): void {
      this.httpService.createGetRequest(configs['api']['fetchTimeWindow'] + this.order_id).subscribe((response: any) => {
        this.multiSelectTimeWindow = this.toObject("multi-select", response);
        this.timeWindowList = this.toObject('', response);
      },
  
      );
    }
  
    private fetchApplicationVersionList(): void {
      this.httpService.createGetRequest(configs['api']['fetchAppversion'] + this.order_id).subscribe((response: any) => {
        this.multiSelectAppVersion = this.toObject("multi-select", response);
        this.ApplicationVersionList = this.toObject('', response);
      });
    }
  
    private fetchAppList(): void {
      this.httpService.createGetRequest(configs['api']['fetchApp'] + this.order_id).subscribe((response: any) => {
        this.appsList = this.toObject("", response);
        this.multiselectAppsList = this.toObject("multi-select", response);
      });
    }
  
    private fetchCitiesList(): void {
      this.httpService.createGetRequest(configs['api']['fetchLocation'] + this.order_id).subscribe((response: any) => {
        this.dropdownList = this.toObject("multi-select", response);
        this.locationList = this.toObject('', response);
      });
    }
  
    public fetchTestIds(url): void {
      let token: any = localStorage.getItem('authKey');
      this.httpService.createPostRequest(url, { "json": { "request": { "data": { "orderId": this.order_id, }, "session": { "sessionId": token } } } }, '').subscribe((res) => {
        if (res && res['json'] && res['json']['response'] && res['json']['response']['data'] && res['json']['response']['data']['list'] && res['json']['response']['data']['list'].length > 0) {
          this.testIdsArray = res['json']['response']['data']['list'];
          this.pagecount = res['json']['response']['data']['count'];
    let testIdDetails=localStorage.getItem('testIdDetails')?JSON.parse(localStorage.getItem('testIdDetails')):'';
    if(testIdDetails) {
      this.updateTestIdMethod( testIdDetails );}else{

       for (let index = 0; index < this.testIdsArray.length; index++) {
            const element = this.testIdsArray[index];
            if (element && (element['pcapAvailability'] && (element['pcapAvailability'].toLowerCase() == "processed"))) {
              this.updateTestIdMethod({ testIdDetails: element });
              break;
            }
          }}
        }
      },(error)=>{
                if(error && error['statusCode'] != 404)
alert(`We are experiencing some issues with our services. Please bear with us as our engineers are solving the problem. 

If you're facing such issues frequently or are stuck, please reach out to us at aquamark-support@mozark.ai and we will reach out to you as soon as possible. 
                  `);
      });
    }
  
    public getDataAsString(data) {
      let arr = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element && element['item_text'])
          arr.push(element['item_text']);
      }
      return arr;
    }
  
    private fetchSpeedList(): void {
      this.httpService.createGetRequest(configs['api']['fetchSpeed'] + this.order_id).subscribe((response: any) => {
        this.multiSelectSpeed = this.toObject("multi-select", response);
        this.speedList = this.toObject('', response);
      });
    }
     
    private fetchPlatformList():void{
      this.httpService.createGetRequest(configs['api']['fetchPlatform'] + this.order_id).subscribe((response: any) => {
        this.multiSelectPlatform = this.toObject("multi-select", response);
      });
    }

    private fetchNetworkList(): void {
  
      this.httpService.createGetRequest(configs['api']['fetchNetworks'] + this.order_id).subscribe((response: any) => {
        if (response) {
          this.multiSelectNetwork = this.toObject("multi-select", response);
          this.networkList = this.toObject('', response);
        }
      });
    }
  
    private fetchKpiList(): void {
      this.httpService.createGetRequest(configs['api']['fetchKpiList'] + this.order_id+'?raw='+false).subscribe((response: any) => {
        if (response)
          this.kpiList = this.toObject('', response);
      });
    }
  
  
  
    private detectDevice(width: number): void {
      let windowWidth = width || document.documentElement.clientWidth || document.body.clientWidth;
      if (windowWidth <= 767)
        this.isMobile = true;
      else {
        var body = document.getElementsByTagName('body')[0];
        this.isMobile = false;
        if (body && body.classList.contains('sidebar-active'))
          body && body.classList.remove('sidebar-active');
      }
  
  
      if (windowWidth <= 991)
        this.customMobileWidth = true;
      else
        this.customMobileWidth = false;
  
      //show or hide side bar toggle button based on screen size
      if (windowWidth <= 1199)
        this.showSideBarComponent = true;
      else
        this.showSideBarComponent = false;
  
      //show or hide side bar toggle button based on screen size
      if (windowWidth <= 1599)
        this.isDesktopMode = true;
      else
        this.isDesktopMode = false;
  
    }
    public exportToExcel(url): void {
      var link: any = document.createElement("a");
      link.href = url;
  
      //set the visibility hidden so it will not effect on your web-layout
      link.style = "visibility:hidden";
      link.download = "export.xls"; //fileName + ".csv";
  
      //this part will append the anchor tag and remove it after automatic click
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.csvUrl="";
    }
    public scroll(element: HTMLElement): void { // scrolls to the respective section
      element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
   
  }
  